// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-select/dist/vue-select.css
// module id = R870
// module chunks = 1